import React, { useState } from "react";
import { OrganisationOption } from "../APIs/Organisation/GetOrganisations";

interface OrganisationSelectionContentProps {
  organisations: OrganisationOption[];
  onSelect: (organisationId: string) => void;
}

const OrganisationSelectionContent: React.FC<
  OrganisationSelectionContentProps
> = ({ organisations, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOrganisations = organisations.filter((org) =>
    org.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600">Please select your organisation:</p>
      <input
        type="text"
        placeholder="Search organisations..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        autoComplete="none"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
      <div
        className="space-y-2 max-h-60 overflow-y-auto"
        style={{ maxHeight: "50vh" }}
      >
        {filteredOrganisations.length > 0 ? (
          filteredOrganisations.map((org) => (
            <button
              key={org._id}
              onClick={() => onSelect(org._id)}
              className="w-full text-left p-3 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {org.title}
            </button>
          ))
        ) : (
          <p className="text-sm text-gray-500 text-center py-4">
            No organisations found matching your search.
          </p>
        )}
      </div>
    </div>
  );
};

export default OrganisationSelectionContent;
